import MuxVideo, { Props } from '@mux/mux-video-react';
import { forwardRef } from 'react';

type StarMuxVideoProps = Partial<Omit<Props, 'ref'>>;

const StarMuxVideo = forwardRef<HTMLVideoElement, StarMuxVideoProps>(({ renditionOrder = 'desc', minResolution = '720p', ...props }, ref) => {
    return <MuxVideo ref={ref} renditionOrder={renditionOrder} minResolution={minResolution} preload="auto" {...props} />;
});

StarMuxVideo.displayName = 'StarMuxVideo';

export default StarMuxVideo;
